import LazyLoad from "./LazyLoad";
import Forms from "./Forms";
import { gsap } from "gsap";

export default class LoadPosts {
    constructor(parent, url) {
        this.parent = parent;
        this.url = url;
        this.$parent = null;
        this.$paginatedItems = null;
        this.$pagination = null;
        this.paginationNumbers = ".page-numbers";
        this.lazy = new LazyLoad();
        this.form = new Forms();
    }

    init() {
        this.$parent = $(this.parent);

        if(!this.$parent.length) return;

        let self = this;
        this.$paginatedItems = this.$parent.find(".js-paginated-items");
        this.$pagination = this.$parent.find(".js-pagination");

        // this.getPagination(1);
        //
        // $(document).on('click', this.paginationNumbers, function(e) {
        //     e.preventDefault();
        //     let selectedPage = $(this).html();
        //     let selected = $(this);
        //     let currentPageNumber = $('.page-numbers.current').html();
        //
        //     switch (selected.attr('href')) {
        //         case '#next':
        //             self.getPagination(parseInt(currentPageNumber)+1, $('#cat').val(), $('#subcat').val());
        //             break;
        //         case '#prev':
        //             self.getPagination(parseInt(currentPageNumber)-1, $('#cat').val(), $('#subcat').val());
        //             break;
        //         default:
        //             self.getPagination(selectedPage, $('#cat').val(), $('#subcat').val());
        //     }
        // });

        // $(document).on('change', '#category', function (e) {
        //     if(e.target.value == 7) {
        //         $('#cat').val('');
        //         $('#subcat').val('');
        //         $('#subcategory').parent().remove();
        //         self.getPagination(1);
        //     } else {
        //         $('#subcategory').parent().removeClass('disabled');
        //         self.getPagination(1, e.target.value, 0);
        //         $('#cat').val(e.target.value);
        //         $('#subcat').val(0);
        //     }
        // });
        //
        // $(document).on('change', '#subcategory', function (e) {
        //     self.getPagination(1, $('#cat').val(), e.target.value);
        //     $('#subcat').val(e.target.value);
        //
        // });

        //this.getCategories();

        // $(document).on('change', '#category', function (e) {
        //     let category_slug = e.target.value;
        //     let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?category=' + category_slug;
        //     window.history.pushState({ path: newurl }, '', newurl);
        //
        //     if(e.target.value !== 'svi-proizvodi') {
        //         self.getSubcategories(e.target.value);
        //         $('#subcategory').parent().removeClass('disabled');
        //     }
        // });
        //
        // $(document).on('change', '#subcategory', function (e) {
        //     //self.getPagination(1, $('#cat').val(), e.target.value);
        //
        //
        // });
    }

    // getCategories() {
    //     (async () => {
    //         const rawResponse = await fetch(apiUrl+ 'getallcategories', {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'Access-Control-Allow-Origin' : 'X-Requested-With',
    //                 'X-WP-Nonce' : apiUserNonce
    //             },
    //             body: JSON.stringify({})
    //         });
    //         const response = await rawResponse.json();
    //
    //         //console.log(response);
    //     })();
    // }
    //
    // getSubcategories(category_slug) {
    //     (async () => {
    //         const rawResponse = await fetch(apiUrl+ 'getsubcategoriesbycategoryslug', {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'Access-Control-Allow-Origin' : 'X-Requested-With',
    //                 'X-WP-Nonce' : apiUserNonce
    //             },
    //             body: JSON.stringify({ cat_slug: category_slug })
    //         });
    //         const response = await rawResponse.json();
    //         response.unshift({
    //            term_id: 0,
    //            name: 'Svi proizvodi',
    //            slug: 'svi-proizvodi',
    //             term_group: 0,
    //             term_taxonomy_id: null,
    //             taxonomy: 'product-category',
    //             description: '',
    //             parent: null,
    //             count: null,
    //             filter: 'raw',
    //             cat_ID: null,
    //             category_count: 1,
    //             category_description: "",
    //             cat_name: 'Svi proizvodi',
    //             category_nicename: 'svi-proizvodi',
    //             category_parent: null
    //         });
    //
    //         let subcategories_element = '';
    //         response.forEach((subcategory) => {
    //             subcategories_element += `<option value="${subcategory.slug}" selected="">${subcategory.name}</option>`;
    //         });
    //
    //         let select = `<div class="select-wrapper js-custom-select has-value">
    //
    //                         <select id="subcategory" name="subcategory">
    //                             ${subcategories_element}
    //                         </select>
    //
    //                         <div class="custom-select">
    //                             <div class="placeholder">
    //                                 <span class="text">Svi proizvodi</span>
    //                                 <span class="icon icon-arrow-head-down"></span>
    //                             </div>
    //                             <div class="dropdown-items">
    //                                 <div class="items"></div>
    //                             </div>
    //                         </div>
    //
    //                         <span class="wpcf7-form-control-wrap subcategory"></span>
    //
    //                     </div>`;
    //         $('.filter--2').html(select);
    //         this.form.customSelect();
    //
    //         console.log(select);
    //     })();
    // }

    // getPagination(page, category, subcategory) {
    //     let self = this;
    //     (async () => {
    //         const rawResponse = await fetch(self.url, {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'Access-Control-Allow-Origin' : 'X-Requested-With',
    //                 'X-WP-Nonce' : apiUserNonce
    //             },
    //             body: JSON.stringify({page: page, category: category, subcategory: subcategory})
    //         });
    //         const response = await rawResponse.json();
    //
    //         if (response.subcategories !== undefined && response.subcategories.length === 0) {
    //             $('#subcategory').parent().remove();
    //             $('#subcat').val(0);
    //         }
    //
    //
    //         if(response.items_list === '') {
    //             self.$paginatedItems.html('<p style="margin-top: 60px;margin-left: 45px;">'+ noresultsmessage +'</p>');
    //         } else {
    //             self.$paginatedItems.html(response.items_list);
    //         }
    //         self.$pagination.html(response.pagination);
    //
    //         if(response.subcategories_partial !== '') {
    //             $('.filter--2').html(response.subcategories_partial);
    //             $('#subcategory').prepend('<option selected value="0">Svi proizvodi</option>');
    //             self.form.customSelect();
    //             $('#subcategory').parent().removeClass('disabled');
    //         }
    //
    //
    //         self.lazy.init();
    //
    //         gsap.to("html", .8, {
    //             scrollTop: self.$parent.offset().top,
    //             ease: "Expo.easeInOut"
    //         });
    //     })();
    // }
}


// WEBPACK FOOTER //
// ./static/js/components/LoadPosts.js